import React from 'react';
// @ts-expect-error ts-migrate(2305) FIXME: Module '"react-router"' has no exported member 'Ro... Remove this comment to see the full error message
import { RouterHistory } from 'react-router';

import { RecommendedJobsBlockData } from 'api/cms';
import { CurrentUser } from 'api/currentUser';
import Box from 'components/Box';
import { colors, gutterWidth } from 'theme';

import { AmpCmsRecommendedJobs } from './Amp';
import { StandardCmsRecommendedJobs } from './Standard';

type BaseProps = {
  data: RecommendedJobsBlockData;
  fromCheckbox?: boolean;
};
type StandardProps = BaseProps & {
  context?: 'standard';
  currentUser: CurrentUser | null | undefined;
  history: RouterHistory;
};
type AmpProps = BaseProps & {
  context: 'amp';
};
type CmsRecommendedJobsBlockProps = AmpProps | StandardProps;

const isAmpContext = (props: CmsRecommendedJobsBlockProps): boolean =>
  props.context === 'amp';

const getSource = (props: CmsRecommendedJobsBlockProps) =>
  props.fromCheckbox ? 'RECOMMENDED_JOBS_CHECKBOX' : 'RECOMMENDED_JOBS_BLOCK';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const Content = (props: CmsRecommendedJobsBlockProps) => {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/destructuring-assignment
  const { headline, layout, jobFunction } = props.data;
  const source = getSource(props);

  if (isAmpContext(props)) {
    return (
      <AmpCmsRecommendedJobs
        headline={headline}
        layout={layout}
        jobFunction={jobFunction}
        source={source}
      />
    );
  }

  const {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentUser' does not exist on type 'Cms... Remove this comment to see the full error message
    currentUser,
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'history' does not exist on type 'CmsReco... Remove this comment to see the full error message
    history,
  } = props;
  return (
    <StandardCmsRecommendedJobs
      headline={headline}
      layout={layout}
      jobFunction={jobFunction}
      source={source}
      currentUser={currentUser}
      history={history}
    />
  );
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
export const CmsRecommendedJobsBlock = (
  props: CmsRecommendedJobsBlockProps
) => {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/destructuring-assignment
  const { layout, jobFunction } = props.data;
  const dataProps = {
    'data-qa-id': 'recommended-jobs',
    'data-qa-layout': layout,
    'data-qa-source': getSource(props),
    'data-qa-job-function': jobFunction,
  };

  if (layout === 'SLIM') {
    // Additional gutter to position the arrows within the box
    const additionalXGutter = 76;
    return (
      <Box
        mx={[-gutterWidth / 2, null, -gutterWidth]}
        py={[gutterWidth / 2, null, gutterWidth]}
        px={[
          gutterWidth / 2,
          gutterWidth,
          gutterWidth + additionalXGutter,
          gutterWidth + additionalXGutter,
        ]}
        bg={colors.lightGrey}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...dataProps}
      >
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/jsx-props-no-spreading, @typescript-eslint/no-explicit-any */}
        <Content {...(props as any)} />
      </Box>
    );
  }

  return (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Box {...dataProps}>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/jsx-props-no-spreading, @typescript-eslint/no-explicit-any */}
      <Content {...(props as any)} />
    </Box>
  );
};
